import React from 'react';
import { Link } from '@inertiajs/react';
// import logo from '@/assets/logo.png';
import logoBlack from '@/assets/logo-black.png';


export default function Logo({ size = 'default' }) {
  const sizeClasses = {
    small: 'h-8',
    default: 'h-10',
    large: 'h-12'
  };

  return (
    <Link href="/" className="flex items-center ">
      <img
        src={logoBlack}
        alt="REZY"
        className={`${sizeClasses[size]}`}
      />
      <span className='ml-1 text-black font-bold'>REZY</span>
    </Link>
  );
}
